import { render, staticRenderFns } from "./Rekomendasi_izin_praktik.vue?vue&type=template&id=9a3ffd24&"
import script from "./Rekomendasi_izin_praktik.vue?vue&type=script&lang=js&"
export * from "./Rekomendasi_izin_praktik.vue?vue&type=script&lang=js&"
import style0 from "./Rekomendasi_izin_praktik.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports